import types from './types';

const getVersion = ({axiosConfig, api}) => ({
	type: types.GET_VERSION,
	params: { axiosConfig, api }
});

export default {
	getVersion
};
